import axios from 'axios'

const SERVER_URL = process.env.VUE_APP_API_BASE

/**
 * 결제 취소 요청
 * @param {Object} paymentInfo - 결제 정보 { Tid, Amt, AreaSeq, CarNum, GoodsName }
 * @returns {Promise<Object>} 취소 결과
 */
export async function requestCancelPayment(paymentInfo) {
  if (!paymentInfo?.Tid) {
    throw new Error('Tid가 없는 결제 정보입니다. 취소할 수 없습니다.')
  }

  // GoodsName 생성 (AreaSeq_SomeId_CarNum 형태)
  const goodsName = paymentInfo.GoodsName || `${paymentInfo.AreaSeq || ''}_${paymentInfo.PaymentSeq || ''}_${paymentInfo.CarNum || ''}`

  const payload = {
    Tid: paymentInfo.Tid,
    CancelAmt: paymentInfo.Amt || 0,
    CancelSeq: '1',
    PartialCancelCode: '0',
    CancelMsg: '사용자 요청 취소',
    GoodsName: goodsName,
    areaSeq: paymentInfo.AreaSeq || '',
    areaId: paymentInfo.AreaSeq || ''
  }

  console.log('[requestCancelPayment] 취소 요청 시작:', { SERVER_URL, payload })

  try {
    const resp = await axios.post(`${SERVER_URL}/api_pay/cancel`, payload)
    console.log('[requestCancelPayment] 응답:', resp.data)

    if (resp.data) {
      return resp.data
    } else {
      console.warn('[requestCancelPayment] 응답 데이터 없음')
      throw new Error('취소가 완료되었으나 결과를 가져올 수 없습니다.')
    }
  } catch (err) {
    console.error('[requestCancelPayment] catch 블록 실행됨')
    console.error('[requestCancelPayment] 오류 데이터:', err.response?.data)
    console.error('[requestCancelPayment] 오류 메시지:', err.message)

    // DB에서 결과 조회 시도
    try {
      console.log('[requestCancelPayment] DB에서 결과 조회 시도:', paymentInfo.Tid)
      const resultResp = await axios.get(`${SERVER_URL}/api/admin/pay-cancel-result`, {
        params: { tid: paymentInfo.Tid }
      })
      console.log('[requestCancelPayment] DB 조회 응답:', resultResp.data)

      if (resultResp.data?.data) {
        return resultResp.data.data
      } else {
        throw new Error('취소 요청 중 오류가 발생했습니다.')
      }
    } catch (dbErr) {
      console.error('[requestCancelPayment] DB 조회 실패:', dbErr)
      throw new Error('취소 요청 중 오류가 발생했습니다.')
    }
  }
}

/**
 * 결제 취소 처리 (확인 창 + 요청 + 결과 반환)
 * @param {Object} paymentInfo - 결제 정보 { Tid, Amt }
 * @returns {Promise<Object|null>} 취소 결과 또는 null (취소됨)
 */
export async function handleCancelPayment(paymentInfo) {
  if (!paymentInfo?.Tid) {
    alert('Tid가 없는 결제 정보입니다. 취소할 수 없습니다.')
    return null
  }

  const confirmMsg = `Tid: ${paymentInfo.Tid}\n금액: ${paymentInfo.Amt ? paymentInfo.Amt.toLocaleString() : 0}원\n정말 취소하시겠습니까?`
  if (!confirm(confirmMsg)) {
    return null
  }

  try {
    const result = await requestCancelPayment(paymentInfo)
    return result
  } catch (error) {
    alert(error.message)
    return null
  }
}
